import './basic-item-card.scss'

import { defineComponent, PropType } from 'vue';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'

import { Item } from '@skinsoft/types';
import { itemSelectors } from '@skinsoft/selectors';

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { Touchable, LocalizedString } from '@skinsoft/ui';
import { Media } from '@skinsoft/ui/src/item-card/media';
import { BASIC_ITEM_CARD_TITLE_CLICKED } from '../../../events';

export interface DesactivatedFields {
    title?: boolean,
    itemType?: boolean,
}

export const BasicItemCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sMedia: Media,
        sLocalizedString: LocalizedString,
        sTouchable: Touchable,
    },
    props: {
        item: {
            type: Object as PropType<Item>,
            required: true,
        },
        excludedFields: {
            type: Object as PropType<DesactivatedFields>,
        },
        actionsAvailable: {
            type: Boolean,
            default: false,
        },
        clickableTitle: {
            type: Boolean,
            default: false,
        }
    },
    template: require('./basic-item-card.html'),
    data() {
        return {
            titleClickIcon: faExternalLinkAlt,
        }
    },
    computed: {
        inventoryNumber(): string {
            return itemSelectors.inventoryNumber(this.item) ?? ""
        },
        title(): string {
            return itemSelectors.federatedTitle(this.item, this.getAppLocale())
        },
        mediaId(): string {
            return itemSelectors.media(this.item) ?? ""
        },
        itemType(): string {
            const type = itemSelectors.type(this.item)
            if(type) {
                return this.getReadableCardType(type) ?? ""
            }

            return ""
        },
        showTitle(): boolean {
            return (this.excludedFields?.title) !== true
        },
        showItemType(): boolean {
            return (this.excludedFields?.itemType) !== true
        },
    },
    methods: {
        onTitleClicked() {
            if(this.clickableTitle) {
                this.$emit(BASIC_ITEM_CARD_TITLE_CLICKED)
            } else {
                this.$emit('click')
            }
        },
        getReadableCardType(cardType: string, defaultCardTypeKey: string = 'museum'): string {
            const cardTypeKeyMatcher = /^.+?([A-Z][a-z]+)/;
            const cardTypeMatchResult = cardType.match(cardTypeKeyMatcher)
            const typeId = cardTypeMatchResult && cardTypeMatchResult.length > 1 ? cardTypeMatchResult[1].toLowerCase() : defaultCardTypeKey
            return this.$t(`entity.itemTypes.${typeId}`) as string
        },
    },
})
